import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CampsDetailsFormStateService } from '../camp-details-form-state-service';

@Component({
    selector: 'app-camp-visibility',
    templateUrl: './camp-visibility.component.html',
    styleUrls: ['./camp-visibility.component.scss'],
    standalone: false
})
export class CampVisibilityComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    constructor(public state : CampsDetailsFormStateService) { 

    }

    ngOnInit(): void {
     
    }

    public edit(){
        this.state.markAsEdited(this.form);
    }

    public get isOtherItemEdited(){
        return this.state.isOtherItemEdited(this.form);
    }

}
